module.exports = __webpack_public_path__ + "static/media/fachada.634633c5.jpeg";